window.GMaps = require('gmaps');

export default class GoogleMap {
  constructor(wrap, id) {
    this.wrap = wrap;
    this.id   = id;

    // coords
    this.$mapCenterLat  = $(this.wrap).find('.map-center-lat');
    this.$mapCenterLng  = $(this.wrap).find('.map-center-lng');
    this.mapCenterLat   = null;
    this.mapCenterLng   = null;

    // map
    this.map            = null;
    this.markers        = [];
  }

  getMapCenter = ($elLat, $elLng) => {
    this.mapCenterLat = $elLat.html();
    this.mapCenterLng = $elLng.html();
  };

  getMarkerParams = (marker, clsLat, clsLng, clsImg, clsCon) => {
      const $markerLat = $(marker).find(clsLat);
      const $markerLng = $(marker).find(clsLng);
      const $markerImg = $(marker).find(clsImg);
      const $markerCon = $(marker).find(clsCon);
      const params     = {};

      if (!!$markerLat.length) {
        params.lat = $markerLat.html().replace(/\s+/g, '');
      }
      if (!!$markerLng.length) {
        params.lng = $markerLng.html().replace(/\s+/g, '');
      }
      if (!!$markerImg.length) {
        params.img = $markerImg.attr('href');
      }
      if (!!$markerCon.length) {
        params.con = '<div class="map-con">' + $markerCon.html() + '</div>';
      }

      return params;
  };

  setMarker = (marker) => {
    const markerImg = !!marker.img ? marker.img : '/sites/all/themes/mothership/mothership/images/marker.png';

    if (!!marker.lat && !!marker.lng) {
      this.map.addMarker({
        lat: marker.lat,
        lng: marker.lng,
        icon: markerImg,
        infoWindow: {
          content: marker.con
        },
      });
    }
  };

  mapInit = (id, lat, lng) => {
    this.map = new GMaps({
      el: id,
      lat: lat,
      lng: lng,
      zoom: 12,
      disableDefaultUI: false,
      zoomControl: true,
      scaleControl: true
    });
  };

  createMapBlock = (wrap) => {
    const mapTpl = '<div id="map" style="height: 100%; width: 100%;"></div>';

    $(wrap).append(mapTpl);
  };

  addEventListeners = () => {
    // $(document).on('ready', this.mapInitParams)
  };

  init = () => {
    this.createMapBlock(this.wrap);
    this.getMapCenter(this.$mapCenterLat, this.$mapCenterLng);
    this.mapInit(this.id, this.mapCenterLat, this.mapCenterLng);

    const markers = $(this.wrap).find('.map-markers');

    [ ...markers ].forEach(marker => {
      this.setMarker(this.getMarkerParams(marker, '.marker-lat', '.marker-lng', '.marker-img .file a', '.taxonomy-term-description'));
    });
    // this.addEventListeners();
  };
}



// WEBPACK FOOTER //
// ./js/map.js